require('../home.css');
// var languageType = require('./languageCommon.js')
var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'
require('../en.css')
require('./sensorsdata.js')
if(language=='zh-CN'){
    $('body').removeClass('en')
}else{
    $('body').addClass('en')
}
$('.language').on('mouseover',function() {
    $(".choicelanguage").show();
}).on('mouseout',function() {
    $(".choicelanguage").hide();
})
$('.choicelanguage a').eq(0).on('click',function(){
    console.log(window.location)
    window.location.href = window.location.origin+window.location.pathname+'?locale=zh-CN'
    localStorage.setItem('language','zh-CN')
    //window.location.reload();
})
$('.choicelanguage a').eq(1).on('click',function(){
    localStorage.setItem('language','USA');
    window.location.href = window.location.origin+window.location.pathname+'?locale=USA'
     //window.location.reload();
})
$('.choicelanguage a').eq(2).on('click',function(){
 localStorage.setItem('language','JP');
window.location.href = window.location.origin+window.location.pathname+'?locale=JP'
     //window.location.reload();
})
$('.choicelanguage a').eq(3).on('click',function(){
   localStorage.setItem('language','KO');
window.location.href = window.location.origin+window.location.pathname+'?locale=KO'
     //window.location.reload();
})
$('.choicelanguage a').eq(4).on('click',function(){
    localStorage.setItem('language','TH');
 window.location.href = window.location.origin+window.location.pathname+'?locale=TH'
     //window.location.reload();
 })
 $('.choicelanguage a').eq(5).on('click',function(){
     localStorage.setItem('language','TH');
  window.location.href = window.location.origin+window.location.pathname+'?locale=YH'
})
$('.about1').addClass('select');
$('.reservation').css('color','white');
var flagIndex=0;
var flag=0;
$('.reservationCode .close ,.reservationCode .guanbi').on('click',function () {
    $('.reservationCode').fadeOut(300);
    $('.reservation').css('opacity',1);
});
// $('.reservation').on('click',function () {
//     // $('.reservationCode').fadeIn(300);
//     // $('.reservation').css('opacity',0);
// });
$(".about1").on('mouseover',function() {
    $(".aboutLv").show();
})
$(".about1").on('mouseout',function() {
    $(".aboutLv").hide();
})
$(".brand1").on('mouseover',function() {
    $(".choiceBrand").show();
}).on('mouseout',function() {
    $(".choiceBrand").hide();
})

var width = document.documentElement.clientWidth;

$(window).resize(function () {
  //当浏览器大小变化时
  width = document.documentElement.clientWidth;


});
// $('.reservation').on('click',function () {
//     // $('.reservationCode').fadeIn(300);
//     // $('.reservation').css('opacity',0);
// });
$("img").on('dragstart',function(){
    return false;
})

$('.language').on('mouseover',function() {
    $(".choicelanguage").show();
}).on('mouseout',function() {
    $(".choicelanguage").hide();
})
$('.choicelanguage a').eq(0).on('click',function(){
    console.log(window.location)
    window.location.href= window.location.origin+window.location.pathname+'?locale=zh-CN'
    localStorage.setItem('language','zh-CN')
    //window.location.reload();
})
$('.choicelanguage a').eq(1).on('click',function(){
    localStorage.setItem('language','USA');
    window.location.href = window.location.origin+window.location.pathname+'?locale=USA'
     //window.location.reload();
})
$('.choicelanguage a').eq(2).on('click',function(){
 localStorage.setItem('language','JP');
window.location.href = window.location.origin+window.location.pathname+'?locale=JP'
     //window.location.reload();
})
$('.choicelanguage a').eq(3).on('click',function(){
   localStorage.setItem('language','KO');
window.location.href = window.location.origin+window.location.pathname+'?locale=KO'
     //window.location.reload();
})
$('.choicelanguage a').eq(4).on('click',function(){
   localStorage.setItem('language','TH');
window.location.href = window.location.origin+window.location.pathname+'?locale=TH'
    //window.location.reload();
})
$('.choicelanguage a').eq(5).on('click',function(){
    localStorage.setItem('language','TH');
 window.location.href = window.location.origin+window.location.pathname+'?locale=YH'
     //window.location.reload();
 })
var width = document.documentElement.clientWidth;
$(window).resize(function () {
  //当浏览器大小变化时
  width = document.documentElement.clientWidth;

});



// WEBPACK FOOTER //
// ./src/js/team.js